(function () {
  'use strict';

  // Tabs "Dein Trainingstag" (sections/kampfsport-produkte.liquid, Darstellung tabs).
  // Ohne JS sind alle Gruppen untereinander sichtbar. Hier: Tab-Wechsel per Klick,
  // Pfeiltasten, Pos1 und Ende, plus Kauf-Feedback wie in der Bestseller-Rail.

  function initTabs(section) {
    if (section.dataset.trainingstagReady === 'true') return;
    var tabs = Array.prototype.slice.call(section.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || tabs.length !== panels.length) return;
    section.dataset.trainingstagReady = 'true';
    section.classList.add('is-ready');

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function activate(index, moveFocus) {
      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
        tab.classList.toggle('is-active', active);
      });
      panels.forEach(function (panel, i) {
        panel.hidden = i !== index;
      });
      if (moveFocus) tabs[index].focus({ preventScroll: true });
      if (tabs[index].scrollIntoView) {
        tabs[index].scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, false); });
      tab.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        activate(next, true);
      });
    });

    var start = tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; });
    panels.forEach(function (panel, i) { panel.hidden = i !== (start < 0 ? 0 : start); });
    tabs.forEach(function (tab, i) { tab.tabIndex = i === (start < 0 ? 0 : start) ? 0 : -1; });

    // Kauf-Feedback: Haekchen im runden Kaufknopf nach erfolgreichem Hinzufuegen
    var feedbackTimers = new WeakMap();
    section.addEventListener('cart:update', function (event) {
      var data = event.detail && event.detail.data;
      if (!data || data.source !== 'product-form-component' || data.didError) return;
      var productForm = Array.prototype.find.call(
        section.querySelectorAll('product-form-component[data-product-id]'),
        function (form) { return String(form.dataset.productId) === String(data.productId); }
      );
      if (!productForm) return;
      var button = productForm.querySelector('.bestseller-card__button');
      var liveRegion = productForm.querySelector('[data-bestseller-live-region]');
      var card = productForm.closest('.kk');
      var title = card && card.querySelector('.bestseller-card__title');
      if (!button) return;
      button.classList.add('is-added-feedback');
      if (liveRegion) {
        liveRegion.textContent = '';
        window.requestAnimationFrame(function () {
          liveRegion.textContent = (title ? title.textContent.trim() : 'Produkt') + ' wurde hinzugefügt';
        });
      }
      if (feedbackTimers.has(button)) window.clearTimeout(feedbackTimers.get(button));
      feedbackTimers.set(button, window.setTimeout(function () {
        button.classList.remove('is-added-feedback');
        if (liveRegion) liveRegion.textContent = '';
        feedbackTimers.delete(button);
      }, 1800));
    });
  }

  function initAll(root) {
    if (root.matches && root.matches('[data-trainingstag]')) initTabs(root);
    root.querySelectorAll('[data-trainingstag]').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
